import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-23/task-02";

const task: Slide = {
  title: "Which of the listed items does not include a commonly used scale in a listening experiment?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
